function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var previewImage = normalize.previewImage(function (args) {
  tt.previewImage(_extends({}, args, {
    current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME.BYTE);
export default previewImage;